'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Field = require('./Field');

var _Field2 = _interopRequireDefault(_Field);

var _styled = require('./styled');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Text = (_temp2 = _class = function (_PureComponent) {
  _inherits(Text, _PureComponent);

  function Text() {
    var _temp, _this, _ret;

    _classCallCheck(this, Text);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = {
      focused: false
    }, _this.onKeyPress = function (e) {
      if (e.key === 'Enter') {
        var onChange = _this.props.onChange;

        onChange(e);
        _this.setState({ focused: false });
        _this.input.blur();
      }
    }, _this.onFocus = function () {
      if (!_this.props.readOnly) {
        _this.setState({ focused: true });
      }
    }, _this.onBlur = function () {
      if (!_this.props.readOnly) {
        _this.setState({ focused: false });
      }
    }, _this.assignRef = function (node) {
      _this.input = node;
      if (_this.props.inputRef) {
        _this.props.inputRef(_this.input);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Text.prototype.render = function render() {
    var focused = this.state.focused;

    var _props = this.props,
        name = _props.name,
        label = _props.label,
        value = _props.value,
        type = _props.type,
        readOnly = _props.readOnly,
        disabled = _props.disabled,
        size = _props.size,
        error = _props.error,
        placeholder = _props.placeholder,
        onChange = _props.onChange,
        inputProps = _props.inputProps,
        rest = _objectWithoutProperties(_props, ['name', 'label', 'value', 'type', 'readOnly', 'disabled', 'size', 'error', 'placeholder', 'onChange', 'inputProps']);

    return _react2.default.createElement(
      _Field2.default,
      _extends({
        name: name,
        label: label,
        focused: focused,
        readOnly: readOnly,
        disabled: disabled,
        error: error,
        size: size
      }, rest),
      _react2.default.createElement(_styled.Input, _extends({
        type: type || 'text',
        innerRef: this.assignRef,
        name: name || label,
        value: value,
        disabled: disabled,
        error: error,
        size: size,
        readOnly: readOnly,
        placeholder: placeholder,
        onChange: onChange,
        onKeyPress: this.onKeyPress,
        onFocus: this.onFocus,
        onBlur: this.onBlur
      }, inputProps)),
      _react2.default.createElement(_styled.Pencil, null)
    );
  };

  return Text;
}(_react.PureComponent), _class.displayName = 'Field.Text', _class.defaultProps = {
  placeholder: '',
  inputProps: {}
}, _temp2);
Text.propTypes = process.env.NODE_ENV !== "production" ? _extends({}, _Field2.default.propTypes, {
  placeholder: _propTypes2.default.string,
  inputProps: _propTypes2.default.object,
  onChange: _propTypes2.default.func,
  inputRef: _propTypes2.default.func
}) : {};
exports.default = Text;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/li-components/lib/Field/Text.js
// module id = 890
// module chunks = 14